export { default } from './FormControlLabel';